"use client"

import { ChevronRight } from "lucide-react"
import { useState } from "react"
import { cn } from "@/lib/utils"
import { Mail, Phone, Plug } from "lucide-react"
import { Link } from "@inertiajs/react"

const iconMap: { [key: string]: any } = {
  "Numbers": Phone,
  "Emails": Mail,
  "Integrations": Plug,
}


export default function OrgSidebarDropdown({
  label,
  subsections,
  activeSection,
}: {
  label: string
  icon: any
  sectionId: string
  subsections: { id: string; label: string }[]
  activeSection: string
}) {
  const [open, setOpen] = useState(false)
  const IconComponent = iconMap[label] || null

  return (
    <div>
      <button
        onClick={() => setOpen(!open)}
        className="flex w-full items-center gap-3 px-4 py-2 text-sm text-sidebar-foreground/80 hover:bg-sidebar-accent/50"
      >
        {
          iconMap[label] ?
            <IconComponent className="h-4 w-4" />
            :
            "idk"
        }
        <span className="">{label}</span>
        <ChevronRight className={cn("h-4 w-4 ml-auto transition-transform", open && "rotate-90")} />
      </button>

      {open && subsections.map((sub) => (
        <Link
          key={sub.id}
          href={`/organization_settings/${sub.id}`}
          className={cn(
            "flex items-center gap-3 pl-11 pr-4 py-2 text-sm transition-colors",
            activeSection === sub.id
              ? "bg-sidebar-accent text-sidebar-accent-foreground font-medium"
              : "text-sidebar-foreground/80 hover:bg-sidebar-accent/50"
          )}
        >
          {sub.label}
        </Link>
      ))}
    </div>
  )
}

